import { useCallback, useEffect } from "react";
import { CustomButton } from "./CustomButton";
import { Container } from "./Container";
import { TextComponent } from "./TextComponent";
import { Column } from "./Column";
import { Row } from "./Row";

interface ModalSimpleProps {
    children?: React.ReactNode,
    title?: string,
    titleHeader?: string,
    actionExecuted: boolean,
    variant?: string,
    onClose: () => void,
    onAction?: () => void,
    icon?: JSX.Element,
    endButtons?: JSX.Element,
    next?: boolean,
    enableButton?: boolean,
    isLogo?: boolean,
    loading?: boolean,
}

export function ModalSimple({ children, title, titleHeader, actionExecuted, variant = "primary", onClose, onAction, icon, next, enableButton = true, isLogo = true, endButtons, loading = false}: ModalSimpleProps) {

    const modalAction = useCallback(() => {
        onClose();
    }, [onClose]);


    useEffect(() => {
        if (actionExecuted) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        return () => {
            document.body.style.overflow = '';
        };
    }, [actionExecuted]);

    useEffect(() => {
        const handleKeyPress = (event: KeyboardEvent) => {
            if (!actionExecuted || event.key !== 'Escape') return;
            modalAction();
        };
        document.addEventListener('keydown', handleKeyPress);
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [modalAction, actionExecuted]);

    if (!actionExecuted) return null;

    return (
        <dialog className="w-full h-svh bg-[#0000006b] fixed flex justify-center items-center top-0 left-0 z-50 overflow-hidden">
            <article className={`relative bg-white ${variant === "primary"
                ? "sm:w-[30rem] max-sm:h-full max-sm:w-full max-sm:overflow-y-auto"
                : "w-4/5 rounded-lg sm:w-[26rem]"}`}
            >
                {variant === "primary" ?
                    <>
                        <header className={`flex ${titleHeader ? 'justify-between' : 'justify-end'} bg-primary text-white px-4 py-2 items-center max-sm:hidden`}>
                            <TextComponent variant="h5" className="font-bold">
                                {titleHeader}
                            </TextComponent>
                            <button className="text-2xl" onClick={modalAction}>✖</button>
                        </header>
                        {isLogo &&
                            <div className="w-full flex justify-center pt-6 sm:py-4">
                                <img
                                    src="/hookup4u-Logo-BP.png"
                                    alt="unjabbed-logo"
                                    className="w-60"
                                    width={632}
                                    height={192}
                                />
                            </div>
                        }
                    </>
                    :
                    <div className="absolute transform left-1/2 -translate-x-1/2 -top-10">
                        {icon}
                    </div>
                }
                <Column
                    mainAxisAlignment="center"
                >
                    <Column
                        mainAxisAlignment="start"
                        className={`m-5 ${variant === "primary" ? "mt-0 max-sm:mb-0" : "text-center pt-5"} max-sm:h-full`}
                    >
                        <TextComponent variant="h2" className="font-bold text-primary text-center">
                            {title}
                        </TextComponent>
                        <Container className="mt-3 text-gray-500 max-sm:h-full sm:max-h-[30rem] sm:overflow-y-auto">
                            {children}
                        </Container>
                        {enableButton &&
                            <>
                                {variant === "primary" ? (
                                    <Column className="sticky bg-white py-5 sm:pb-0 border border-transparent bottom-0 gap-4">
                                        {endButtons ? 
                                            endButtons
                                            :
                                            <CustomButton onClick={onAction || modalAction}>
                                                Continue
                                            </CustomButton>
                                        }
                                    </Column>
                                ) : (
                                    <>
                                        {next ? (
                                            <Container className="sticky bg-white py-5 pb-0 border border-transparent  bottom-0" >
                                                {endButtons ? 
                                                    endButtons
                                                    :
                                                    <CustomButton onClick={onAction || modalAction}>
                                                        Continue
                                                    </CustomButton>
                                                }
                                            </Container>
                                        ) : (

                                            <Row className="sticky bg-white pt-5 border border-transparent bottom-0 gap-4">
                                                <CustomButton onClick={onAction} className="w-1/2" small loading={loading}>
                                                    Yes
                                                </CustomButton>
                                                <CustomButton onClick={modalAction} className="w-1/2 text-primary" color="white" small>
                                                    No
                                                </CustomButton>
                                            </Row>
                                        )}
                                    </>
                                )}
                            </>
                        }
                    </Column>
                </Column>
            </article>
        </dialog>
    );
}